import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
const styles = theme => ({
    root: {
      flexGrow: 1,
      maxWidth: 1170,
      margin: 'auto',
    }
});

class Footer extends Component {
    componentDidMount(){
        
        var acc = document.getElementsByClassName("accordion_title");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function() {
                if (!this.parentElement.classList.contains('active')) {
                    var currentElement = this;
                    for (i = 0; i < acc.length; i++) {
                        this.parentElement.classList.remove("active");    
                    }
                    currentElement.parentElement.classList.add("active");
                }else{
                    for (i = 0; i < acc.length; i++) {
                        this.parentElement.classList.remove("active");    
                    }
                }
                
            });
        }
    }
    render() {
        const { classes } = this.props;
        return (
            <footer>
                <section className="above_footer">
                    <img className="play_kids" src={require('../../assets/images/footer-kids.png')} />
                    <div className="grass_bg"></div>
                    <div className="bluebg"></div>
                </section>
                <section className="footer">
                    <div className="footer_left">
                        <img src={require('../../assets/images/piggybank.png')} />
                    </div>
                    <div className="footer_center">
                        <p className="title_top">GET IN TOUCH</p>
                        <p className="title_big">Contact</p>
                        <p className="content address">
                            900 Wilshire Drive, Suite 262<br />
                            Troy, MI 48084
                        </p>
                        <p className="ip">313.757.0530</p>
                        <p className="ip"><a style={{color: '#ffffff', 'text-decoration': 'none'}} href="mailto:care@kbaaz.com">care@kbaaz.com</a></p>
                        <p><a href="#"><img src={require('../../assets/images/facebook.png')} /></a></p>
                        <p><a href="#"><i class="fab fa-twitter"></i></a></p>
                        <p className="copyright">&copy; 2018 kbaaz.com, All rights reserved.</p>
                    </div>
                    <div className="footer_right">
                        <p className="title_top">HAVE DOUBTS?</p>
                        <p className="title_big">Most Asked FAQs</p>
                        <p className="content text">Our team is happy to answer your queries. Fill out the form and we'll be in touch as soon as possible.</p>
                        <div className="accordion_section">
                            <div className="accordion_item active">
                                <div className="accordion_title">
                                    <p className="content">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                                </div>
                                <div className="accordion_content">
                                    <p className="content">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                    </p>
                                </div>
                            </div>
                            <div className="accordion_item">
                                <div className="accordion_title">
                                    <p className="content">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                                </div>
                                <div className="accordion_content">
                                    <p className="content">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                    </p>
                                </div>
                            </div>
                            <div className="accordion_item">
                                <div className="accordion_title">
                                    <p className="content">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                                </div>
                                <div className="accordion_content">
                                    <p className="content">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                    </p>
                                </div>
                            </div>
                            <div className="accordion_item">
                                <div className="accordion_title">
                                    <p className="content">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                                </div>
                                <div className="accordion_content">
                                    <p className="content">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </footer>
        )
    }
}

Footer.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(Footer);


// WEBPACK FOOTER //
// ./src/components/Landing/Footer.js